module.exports = __webpack_public_path__ + "img/tesouro.909f2717.png";